import { typographyTokens } from '../../theme/typographyTokens';
import React from 'react';
import { Box, TextField, Typography, InputAdornment, IconButton, useTheme } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import CloseIcon from '@mui/icons-material/Close';

const SearchBar = ({
  title,
  searchText,
  placeHolder,
  setSearchText,
  toggleDrawer,
  reset
}: {
  title: string;
  placeHolder?: string;
  searchText: string;
  setSearchText: (text: string) => void;
  toggleDrawer?:(text: boolean) => void;
  reset?: () => void;
}) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchText(event.target.value);
  };
  const theme = useTheme();
  const isDarkMode = theme.palette.mode === 'dark';
  return (
    <Box      
      mb="16px"
      sx={{
        display:"flex",        
        justifyContent:"space-between",
        alignItems:"center",
        px: { xs: '24px', md: '40px' },
        flexDirection: 'column',
        gap: '14px',
      }}
    >
      <Typography color={isDarkMode ? theme.palette.text.primary : theme.palette.content.default} fontSize={typographyTokens.fontSizes.displaySmall} fontWeight={typographyTokens.fontWeights.bold}>
        {title}
      </Typography>
      <TextField
        placeholder={
          placeHolder ||
          'Search for an SEP, initiative name, requestor, and more…'
        }
        InputProps={{
          startAdornment: (
            <InputAdornment position="start" sx={{ color: theme.palette.prime.orange, mr: 1.5 }}>
              <SearchIcon sx={{ fontSize: typographyTokens.fontSizes.xl }} />
            </InputAdornment>
          ),
          endAdornment: (
            searchText ? (
              <InputAdornment position="end">
                <IconButton
                  size="small"
                  aria-label="Clear search"
                  onClick={() => {
                    setSearchText('');
                    if (reset) reset();
                  }}
                  sx={{ color: theme.palette.prime.granite }}
                >
                  <CloseIcon fontSize="small" />
                </IconButton>
              </InputAdornment>
            ) : null
          ),
        }}
        aria-label="Search TextField"
        value={searchText}
        onChange={handleChange}
        sx={{
          width: '100%',
          maxWidth: '493px',
          backgroundColor: isDarkMode ? theme.palette.background.default : theme.palette.content.white,
          '& .MuiOutlinedInput-root': {
            borderRadius: '999px',
            minHeight: '46px',
            paddingLeft: '12px',
            boxShadow: '0 1px 3px rgba(18, 57, 93, 0.12)',
            '& input': {
              padding: '10px 14px 10px 0',
              color: isDarkMode ? theme.palette.text.primary : theme.palette.content.default,
              fontSize: typographyTokens.fontSizes.base,
              '&::placeholder': {
                fontSize: typographyTokens.fontSizes.base,
                opacity: 1,
                color: isDarkMode ? theme.palette.text.primary : theme.palette.content.default,
              },
            },
            '& fieldset': {
              borderColor: theme.palette.supportingAdditional.tealContainerStroke,
              borderWidth: '0.5px',
            },
            '&:hover fieldset': {
              borderColor: (theme) => theme.palette.solidBlue.main,
            },
            '&.Mui-focused fieldset': {
              borderColor: (theme) => theme.palette.solidBlue.main,
            },
          },
        }}
      />
      <Box />
    </Box>
  );
};

export default SearchBar;
